import { Config } from '../../../config/index'
import React from 'react'
import styled, { ThemeConsumer } from 'styled-components'
import { IconCheck } from '../Icons'

interface CheckboxProps {
  isChecked?: boolean
  label?: string | JSX.Element
  onChange: (_: string) => void
  name?: string
  value?: string | number
  small?: boolean
  align?: 'flex-start' | 'center' | 'flex-end'
  className?: string
  style?: any
  mobileLabelColor?: string
  mobileBoxAndCheckColor?: string
  labelColor?: string
  boxAndCheckColor?: string
}

export const Checkbox = ({
  isChecked,
  label,
  onChange,
  name,
  value,
  small = false,
  align = 'center',
  style = {},
  mobileLabelColor = Config.palette.primary,
  mobileBoxAndCheckColor = '#aaa',
  labelColor = Config.palette.primary,
  boxAndCheckColor = Config.palette.dark,
  className,
}: CheckboxProps) => {
  return (
    <Container>
      <Label
        align={align}
        onClick={() => onChange(value as string)}
        small={small}
        mobileLabelColor={mobileLabelColor}
        labelColor={labelColor}
      >
        <Input type="checkbox" name={name} />
        <Span
          style={style}
          cName={className}
          isChecked={isChecked}
          boxAndCheckColor={boxAndCheckColor}
          mobileBoxAndCheckColor={mobileBoxAndCheckColor}
        >
          {isChecked && <IconCheck />}
        </Span>
        {label}
      </Label>
    </Container>
  )
}

type StyledProps = {
  small?: boolean
  isChecked?: boolean
  align?: string
  cName?: string
  mobileLabelColor?: string
  labelColor?: string
  mobileBoxAndCheckColor?: string
  boxAndCheckColor?: string
}

const Container = styled.div`
  word-break: break-word;
  box-sizing: border-box;
  user-select: none;
  line-height: 1;
`

const Label = styled.div<StyledProps>`
  display: inline-flex;
  align-items: ${(props) => props.align};
  font-size: ${(props) => (props.small ? '1.6rem' : '1.8rem')};
  cursor: pointer;
  position: relative;
  height: 100%;
  line-height: 1.6;

  color: ${({ mobileLabelColor }) => mobileLabelColor};
  transition: color 0.25s ease;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    color: ${({ labelColor, theme }) =>
      !labelColor ? theme.palette.primary : labelColor};
  }

  &:hover {
    opacity: 0.7;
  }
`

const Input = styled.input`
  display: none;
`

const Span = styled.span.attrs((props: any) => ({
  className: `mr-3 d-flex align-items-center justify-content-center ${props.cName}`,
}))<StyledProps>`
  height: 1.6rem;
  width: 1.6rem;

  border-radius: 0.2rem;
  position: relative;

  background-color: #f5f5f5;
  border-radius: 0;

  color: ${({ mobileBoxAndCheckColor }) => mobileBoxAndCheckColor};
  border: 0.1rem solid ${({ mobileBoxAndCheckColor }) => mobileBoxAndCheckColor};

  position: relative;

  ${({ isChecked }) =>
    isChecked &&
    `
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0.4rem;
      left: 0.4rem;
      width: 0.6rem;
      height: 0.6rem;
      background: #222;
    }
  `}

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    min-width: 1.7rem;
    max-width: 1.7rem;
    height: 1.7rem;

    color: ${({ boxAndCheckColor }) => boxAndCheckColor};
    border: 0.1rem solid ${({ boxAndCheckColor }) => boxAndCheckColor};
    background: transparent;
    border-radius: 0.2rem;

    &::after {
      display: none;
    }
  }

  & svg {
    width: 1.1rem;
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
      display: block;
    }
  }
`
